import { render, staticRenderFns } from "./ExtraPages.vue?vue&type=template&id=52f3bf7d&scoped=true&"
import script from "./ExtraPages.vue?vue&type=script&lang=js&"
export * from "./ExtraPages.vue?vue&type=script&lang=js&"
import style0 from "./ExtraPages.vue?vue&type=style&index=0&id=52f3bf7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f3bf7d",
  null
  
)

export default component.exports